import { get, post } from './httpClient'

export const getAllProduct = (params) => get('/product', { ...params })
export const updateProduct = (body) => post('/product/updateproduct', body)
export const getAllProductType = (params) => get('/producttype', { ...params })
export const getAllProductTypeGroup = () => get('/producttype/allgroup')
export const createProduct = (body) => post('/product/createproduct', body)
export const searchProduct = (object) => get('/product', object)
export const deleteProduct = (object) => post('/product/removeproduct', object)
